define([
    'common/domain/entity/blob',
    'i18next',
    'dropzone',
    'backbone'
], function(
    BlobModel,
    i18next,
    Dropzone
    ){
    /**
     * アップロードに成功した際に呼ばれるコールバック。
     *
     * アップロードした画像の情報を渡す。
     * @callback BlobUploader~onSuccessCallback
     * @param file {File} - アップロード成功した blob の File object
     * @param url {string} - アップロード成功した blob を取得するための URL(path)
     * @param content_type {string} - アップロードした blob の mime type
     */
    /**
     * アップロードに失敗した際に呼ばれるコールバック。
     * @callback BlobUploader~onErrorCallback
     * @param res {object} - レスポンス
     */
    /**
     * アップロードする際に呼ばれるコールバック。
     *
     * レスポンスが返ってくるまでボタンを disable したりするのに使う。
     * @callback BlobUploader~onUploadCallback
     */
    var Uploader = Backbone.View.extend(
        /**
         * @lends BlobUploader.prototype
         */
        {
            className: 'dropzone',
            /**
             * Blob をアップロードするためのクラス
             * @constructs
             *
             * @param params
             * @param params.blobApi {string} - Blob アップロード用 URL 取得用の API オブジェクト(.getUploadUrl() を持つ)
             * @param params.imageOnly {boolean} - true の場合 image 以外を受け付けなくなる
             * @param params.onSuccess {BlobUploader~onSuccessCallback} - アップロードに成功した際に呼ばれるコールバック
             * @param params.onError {BlobUploader~onErrorCallback} - アップロードに失敗した際に呼ばれるコールバック
             * @param params.onUpload {BlobUploader~onUploadCallback} - アップロードする際に呼ばれるコールバック
             */
            initialize: function(params) {
                _.bindAll(this, 'success', 'error', 'setUploadUrl');

                if(!params.blobApi) {
                    throw 'Invalid parameter: params.upload_api is required.';
                }

                // dropzone は jquery object を渡すと駄目なので el にしておく
                this._blobApi = params.blobApi;
                this._imageOnly = params.imageOnly;
                this.onsuccess = params.onSuccess;
                this.onerror = params.onError;
                this.onupload = params.onUpload;

                var p = {
                    paramName: 'blob',
                    url: 'tmp',
                    maxFilesize: 5
                };
                if(this._imageOnly) {
                    p.acceptedFiles = 'image/*';
                }
                p = _.extend(p, i18next.t('uploader', {returnObjectTrees: true}));
                this.$dz = new Dropzone(this.$el[0], p);
                this.$dz.on('success', this.success);
                this.$dz.on('error', this.error);
                this.$dz.on('processing', this.uploading);

                this.getUploadUrl();
            },

            reset: function() {
                if (this.default_img_path && this.$image) {
                    this.$image.attr('src', this.default_img_path);
                }
            },

            getUploadUrl: function() {
                this._blobApi.getUploadUrl()
                    .then(this.setUploadUrl, this.error);
            },

            setUploadUrl: function(data) {
                this.$dz.options.url = data.upload_url;
            },

            success: function(file, responseText) {
                var j = JSON.parse(responseText);
                if(this.onsuccess) {
                    this.onsuccess(file, new BlobModel(j));
                }
                this.getUploadUrl();
            },

            error: function(file, errorMessage, xhr) {
                if(this.onerror) {
                    this.onerror(errorMessage);
                }
            },

            uploading: function() {
                if(this.onupload) {
                    this.onupload();
                }
            }
        });

    return Uploader;
});



// WEBPACK FOOTER //
// ./common/ui/view/blob/uploader.js